import React from 'react';
import classNames from 'classnames/bind';

// Style
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './EspecialButton.styl';
import Button from '../../Button';
import Amount from '../../Amount';
import GiftIcon from '../../../icons/gift.svg';

const cx = classNames.bind(styles);

export default function EspecialButton(props) {
  const {
    className,
    onAddToCart,
    compact,
    isLoading,
    newValue,
    value,
    currentSize,
    sizes,
    variation,
    isGift,
  } = props;
  const currentUnit = sizes?.length > 0 && sizes?.[0].unit ? sizes[0].unit : '';
  const unit = useSelector(state => state.city.userCity.currency?.unit);
  const extraEntries =
    variation && typeof variation.extra === 'object' && variation.extra !== null
      ? Object.entries(variation.extra)
      : [];
  const deposit = variation?.deposit || '';
  const deposit_type = variation?.deposit_type || '';

  const hasDeposit = !!deposit;
  const hasExtras = extraEntries.length > 0;

  return (
    <Button
      className={cx({ ProductCard__button_compact: compact }, className, 'EspecialButton')}
      onClick={onAddToCart}
      isLoading={isLoading}
      classNameChildren={cx('EspecialButton__content')}
    >
      <div className={cx('EspecialButton__leftSide')}>
        {currentSize && <div>{`${currentSize} ${currentUnit} ${deposit_type}`}</div>}

        <div className={cx('EspecialButton__leftSide_zalogContainer')}>
          {hasDeposit && (
            <div>
              {hasExtras ? `(ZZGL ${deposit} ${unit} PFAND;` : `ZZGL ${deposit} ${unit} PFAND`}
            </div>
          )}

          {hasExtras && (
            <div>
              {extraEntries.map(([k, v], idx) => {
                const isKg = k !== 'price_per_liter';
                const isLast = idx === extraEntries.length - 1;
                return (
                  <div key={k} className={cx('EspecialButton__extraRow')}>
                    <span className={cx('EspecialButton__extraValue')}>
                      {`${v} ${unit}/1${isKg ? 'KG' : 'L'}${hasDeposit ? (isLast ? ')' : '') : ''}`}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div>
        {isGift ? (
          <GiftIcon
            className={cx('ProductCard__price', 'ProductCard__gift', {
              ProductCard__price_compact: compact,
            })}
          />
        ) : (
          <Amount
            className={cx('EspecialButton__rightSide')}
            value={value}
            newValue={newValue}
            specialStylesMode
          />
        )}
      </div>
    </Button>
  );
}

EspecialButton.defaultProps = {
  className: '',
  value: '-',
  newValue: undefined,
  sizes: [],
  variation: {},
};

EspecialButton.propTypes = {
  className: PropTypes.string,
  onAddToCart: PropTypes.func,
  compact: PropTypes.bool,
  isLoading: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  newValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, undefined]),
  sizes: PropTypes.array,
  variation: PropTypes.object,
};
